<template>
  <div class="content-card-plans">
    <a class="content-card-plans-link" @click="routerPage(methodPayment)">
      <div
        class="content-card-plans--image"
        :style="{
          background: `url(data:image/jpg;base64,${methodPayment.picture})`,
        }"
      ></div>
      <div class="content-card-plans--text">
        <h3>{{ methodPayment.name }}</h3>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: ["methodPayment"],
  methods: {
    routerPage(methodPayment) {
      this.$router.push({
        name: "EditMethodPayment",
        params: {
          id: methodPayment.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-card-plans {
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    display: block;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 10px 10px 0px 0px;
  }
  &--text {
    padding: 15px;
    text-align: center;
    h3 {
      font-size: 20px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px) {
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px) {
        height: 65px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
}
</style>
